import React, { useEffect } from "react";
import icons1 from "../../../Assets/UserSide/NumberProperties.svg";
import icons2 from "../../../Assets/UserSide/experience.svg";
import icons3 from "../../../Assets/UserSide/NumberBeds.svg";
import icons4 from "../../../Assets/UserSide/tenants.svg";

import image1 from "../../../Assets/Images/JayadevVihar.png";
import image2 from "../../../Assets/Images/Patia.png";
import image3 from "../../../Assets/Images/SahidNagar.png";
import image4 from "../../../Assets/Images/Nayapali.png";
import image5 from "../../../Assets/Images/KitSquare.png";
import Aos from "aos";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";

const locations = [
  { name: "JAYDEV VIHAR", image: image1, aos: "zoom-in" },
  { name: "PATIA", image: image2, aos: "zoom-in" },
  { name: "SHAHID NAGAR", image: image3, aos: "zoom-in" },
  { name: "NAYAPALI", image: image4, aos: "zoom-in" },
  { name: "KIIT SQUARE", image: image5, aos: "zoom-in" },
];
const slugify = (str) =>
  str
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^\w-]+/g, "");

const stats = [
  { value: "10+", label: "Properties", icon: icons1, aos: "fade-right" },
  { value: "6+", label: "Years of Experience", icon: icons2, aos: "flip-left" },
  { value: "1000+", label: "No of Beds", icon: icons3, aos: "flip-right" },
  { value: "2000+", label: "Tenants Served", icon: icons4, aos: "fade-left" },
];

export default function States_with_obstacles() {
  const navigate = useNavigate();
  useEffect(() => {
    Aos.init({ duration: 1000 }); // Initialize AOS with a duration of 1000ms
  }, []);
  return (
    <div className="bg-[#e7eef7] sm:p-16 p-6">
      <div className="grid xl:grid-cols-4 md:grid-cols-2 grid-cols-1 justify-between xl:gap-20 gap-5 text-center text-blue-900  ">
        {stats.map((stat, index) => (
          <div
            key={index}
            data-aos={`${stat.aos}`}
            className={`flex flex-row  items-center justify-start text-start  gap-4 md:mb-16 mb-4 sm:border-r-4 sm:border-white xl:border-none${
              index !== stats.length - 1 ? "border-r-4 border-white" : ""
            }  `}
          >
            <div className="text-3xl bg-[#e7f7ff]  rounded-full">
              <img src={stat.icon} alt={stat.icon} className="h-20 w-20" />
            </div>
            <div className="tracking-wide">
              <p className="lg:text-2xl md:text-sm text-xs font-bold text-[#1258C2] ">
                {stat.value}
              </p>
              <p className="lg:text-lg md:text-sm text-xs font-semibold text-black">
                {stat.label}
              </p>
            </div>

            <div className="w-2 bg-white"></div>
          </div>
        ))}
      </div>
      <div className="grid xl:grid-cols-5 lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-4 justify-center place-items-center">
        {locations.map((location, index) => (
          <div
            key={index}
            data-aos={`${location.aos}`}
            className="relative overflow-hidden rounded-lg shadow-xl sm:w-56 w-full text-center cursor-pointer"
            onClick={() => navigate(`/${slugify(location.name)}`)}
          >
            <img
              src={location.image}
              alt={location.name}
              className="w-full h-40 object-cover transition-all duration-300"
            />
            <div className="absolute bottom-0 bg-black opacity-40 transition-all duration-300 hover:opacity-10 w-full h-full p-2"></div>
            <p className="text-white absolute top-[75%] inset-0  font-bold tracking-wide  ">
              {location.name}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
